import {
  Button,
  Filters,
  Header,
  Search,
  Select,
  StickyFooterButtons,
  useBreakpoints,
  useLoading,
  ValueOpt,
} from "best-common-react";
import React, { useEffect, useState } from "react";
import { getVenues } from "../../../api/RequesTixApi";
import CopyVenueDataModal from "../../../components/venue/CopyVenueDataModal";
import VenueTable from "../../../components/venue/VenueTable";
import { useAdminYear } from "../../../contexts/AdminYearContext";
import { useDropdowns } from "../../../contexts/DropdownsContext";
import { VenueDTO } from "../../../types/Venue";

const AdminVenues = () => {
  const { setLoading } = useLoading();
  const { isMobile } = useBreakpoints();
  const [venues, setVenues] = useState<VenueDTO[]>([]);
  const { yearsOptions } = useDropdowns();
  const [selectedYear, setSelectedYear] = useAdminYear();
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [openCopyData, setOpenCopyData] = useState<boolean>(false);

  const fetchVenues = async (selectedYear: ValueOpt<number>) => {
    try {
      setLoading(true);
      const res: VenueDTO[] = await getVenues(selectedYear.value);
      setVenues(res);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    void fetchVenues(selectedYear);
  }, [selectedYear]);

  return (
    <div>
      <CopyVenueDataModal isOpen={openCopyData} setIsOpen={setOpenCopyData} />
      <Header title="Venues" flexColumn>
        <Filters actionIconPosition="absolute" numberDisplayed={isMobile ? 1 : 2}>
          <Select
            id="years-dropdown"
            label="Year"
            options={yearsOptions}
            value={selectedYear}
            onChange={setSelectedYear}
            gutterBottom
          />
          <Search
            id="search-box"
            label="Search Venues"
            placeholder="begin typing to filter venues"
            value={searchTerm}
            onChange={setSearchTerm}
            gutterBottom
          />
        </Filters>
      </Header>
      <div className="bcr-p-2">
        <div className="bcr-mb-2">
          <VenueTable values={venues} searchTerm={searchTerm} />
        </div>
        <StickyFooterButtons startsOpen={true}>
          <Button variant="default" onClick={() => setOpenCopyData(true)}>
            Copy Venue Data
          </Button>
        </StickyFooterButtons>
      </div>
    </div>
  );
};

export default AdminVenues;
